const GO_ROOT = 'https://partner-gateway.qschou.com'
const THUMB_ROOT = 'https://images-partner.qschou.com'

export default {
    oss: `${GO_ROOT}/test/upload/ossv1`,
    thumb: `${THUMB_ROOT}`
}